// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1A8-_","loaderOuter":"PageOverlayLoader_loaderOuter__2bQSU"};